export const url = `${process.env.REACT_APP_API_URL || ""}/api/v1`;
